import { createFileRoute } from '@tanstack/react-router';
import { ManageContactsPage } from '@/pages/member-portal/contacts/ManageContactsPage';

function MemberPortalManageContactsRoute() {
	return <ManageContactsPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/manage/contacts')({
	component: MemberPortalManageContactsRoute,
});
